export default ({error, selected, hovered}) => {
  let borderColor;
  let methodTextColor;
  let descriptionTextColor;

  if (error) {
    borderColor = '#D32F2F';
    descriptionTextColor = '#D32F2F';
    methodTextColor = '#D32F2F';
  } else if (hovered) {
    borderColor = '#16B9D4';
    descriptionTextColor = 'inherit';
    methodTextColor = '#16B9D4';
  } else if (selected) {
    borderColor = '#0C7C84';
    descriptionTextColor = 'inherit';
    methodTextColor = '#0C7C84';
  } else {
    borderColor = '#E7E7E7';
    descriptionTextColor = 'inherit';
    methodTextColor = 'inherit';
  }

  return {
    borderColor,
    descriptionTextColor,
    methodTextColor,
  };
};